import { DefaultCharacter } from "../assets";
import React from "react";
import { Dialog } from "../components/Dialog";
import Head from "../components/Head";
import { Flex, Heading, Box, Text } from "@chakra-ui/react";
import { Large } from "../components/Type";
import Link from "../components/Link";

import Image from "next/image";

export default function ComingSoon() {
    return (
        <>
          <Head title="coming soon" />
          <Flex
            paddingX={[4, 0, 0]}
            alignItems="center"
            justifyContent="center"
            h="100vh"
            direction="column"
          >
            <Dialog
              padding={["32px 24px", "48px 54px"]}
              backgroundColor="whitish"
              w={["90%", "586px"]}
              h={["auto", "353.296875px"]}
              borderRadius="6px"
              borderWidth="1px"
            >
              <Flex
                justifyContent="center"
                alignItems="center"
                direction="column"
                textAlign="center"
                gap="32px"
                h="100%"
              >
                <Box mb={8} mx="auto" w="235px" h="140px">
                  <Image
                    src={DefaultCharacter}
                    alt="Coming Soon"
                    width={235}
                    height={140}
                  />
                </Box>
                <Box>
                <Large fontSize={["lg", "xl", "3xl"]}>
                まもなく公開、お楽しみに！
                </Large>
                <Text fontSize={["md", "md", "lg"]} color="gray.600" mt={2}>
                素敵な機能とコンテンツが待ってます！
                </Text>
                </Box>
              </Flex>
            </Dialog>
          </Flex>
        </>
      );
}
